/** Is er meer inhoud dan zichtbaar? 1px marge voor afronding van gebroken regelhoogtes. */
export function isOverflowing(scrollHeight: number, clientHeight: number): boolean {
  return scrollHeight - clientHeight > 1;
}
